import { generateReadOneActionCreator } from "actions/crudActionCreators";
import ACTION_NAMES from "actions/ACTION_NAMES";
import routes from "actions/routes";

export default {
    contactTimelineTab: generateReadOneActionCreator(
        routes.API_CONTACT,
        ACTION_NAMES.CONTACT_TIMELINE,
        "timeline"
    ),
    accountTimelineTab: generateReadOneActionCreator(
        routes.API_ACCOUNT,
        ACTION_NAMES.CONTACT_TIMELINE,
        "timeline"
    ),
    getAccountTimelineContacts: generateReadOneActionCreator(
        routes.API_ACCOUNT,
        ACTION_NAMES.ACCOUNT_TIMELINE_CONTACT,
        "timeline/contacts"
    ),
};
